import { IconButton } from '@rmwc/icon-button'

export default IconButton
